export class MessageTrade {
  public orderid?: string;
  public account: string;
  public market: string;
  public price: string;
  public quote: string;
  public qtd: number;
  public type: string;
  public side: string;
  public username: string;
  public validityorderTemp: Date;
  public validityorder: any;
  public targettrigger: string;
  public targetlimit: string;
  public stoptrigger: string;
  public stoplimit: string;
  public orderStrategy: string;
  public sourceaddress: string;
  public timeinforce?: string;
  public loteDefault: number;
  public origclordid?: string;
  public maxfloor?: string;
  public movingstart?: string;
  public initialchangetype?: string;
  public initialchange?: string;
  public pricepercentage?: string;
  public enteringtrader?: string;
  public minqty?: string;
  public ordertag?: string;
  public fractionaryQtd?: number;
  public bypasssuitability?: boolean;
  public appName: string;
  public contingencytype: string;
  public clordlinkid: string;
  constructor() { }
}
